import { render, staticRenderFns } from "./Centered.vue?vue&type=template&id=648c32cd&scoped=true&"
import script from "./Centered.vue?vue&type=script&lang=js&"
export * from "./Centered.vue?vue&type=script&lang=js&"
import style0 from "./Centered.vue?vue&type=style&index=0&id=648c32cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c32cd",
  null
  
)

export default component.exports